import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { List } from "@mui/material";
import AppIcon from '@mui/icons-material/Apps';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NavItem from '../NavItem';

const AppMenu = () => {
    const { t } = useTranslation();
    const location = useLocation();

    return (
        <List sx={{ px: 1, pt: 2 }}>
            <NavItem to="/" icon={<AppIcon />} label={t('nav.myProjects')} active={location.pathname === '/'} />
            <NavItem to="/user/profile" icon={<AccountBoxIcon />} label={t('nav.profile')} active={location.pathname === '/user/profile'} />
            <NavItem to="/user/log" icon={<ListAltIcon />} label={t('nav.activityLogs')} active={location.pathname === '/user/log'} />
        </List>
    )
}

export default AppMenu;
